export default __webpack_public_path__ + "static/edge.4d63253cb3f31ced223728542ffe63cf.png";